import React from "react"
import types from "prop-types"
import FormsyValidation from "shared/FormsyValidation"

const AnswerOptionsListSelectedValidation = ({ value = null, sectionIndex, questionIndex }) => (
  <FormsyValidation
    name={`sections[${sectionIndex}].questions[${questionIndex}].answerOptionsListSelected`}
    value={value}
    validations={{
      requiresAnswerOptionsList(_model, val) {
        if (val) return true
        return "Must select an answer options list"
      },
    }}
  />
)

AnswerOptionsListSelectedValidation.propTypes = {
  value: types.oneOfType([types.string, types.number]),
  sectionIndex: types.number.isRequired,
  questionIndex: types.number.isRequired,
}

export default AnswerOptionsListSelectedValidation
